import React from "react";
import ReactTooltip from "react-tooltip";

import { getDisplayNameFromKey, getTileName } from "../utils";
import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";

const ViewChartItemForModal = ({
    item,
    chartItemData = null,
    mainEntity,
    currentBand,
    openChartItemConfigModal,
    provided,
    index,
    entity,
    toggleImageListForBandModal,
    openFilterModal,
    isExcelExport = false,
    editImageBand,
    openExecutiveSummaryHierarchyConfig,
    isSouceTemplate,
    hideMemoImageEditControls = false,
    ...props
}) => {
    const tileName = getTileName(item);
    const displayName = getDisplayNameFromKey(item.name, item.isUserDoc);
    return (
        <div className="drag-item">
            <div className="top-sec">
                <div className="icon">
                    <img src="/img/icon-squre.svg" />
                </div>
                <div className="icon-rght-b">
                    {item.isIndividualBuilding ? (
                        <>
                            <ReactTooltip id={`sm-charts-main${entity}`} effect="solid" place="bottom" backgroundColor="#007bff" />
                            <div
                                className="icon-b"
                                data-tip="This chart/table will repeat for every building in scope"
                                data-for={`sm-charts-main${entity}`}
                            >
                                <img src={`/img/sm-charts-all-buildings.svg`} />
                            </div>
                        </>
                    ) : null}
                </div>
                <div class="wrap-icon d-flex">
                    {(item.isMemo || (item?.isExecutiveSummaryParent && !item?.tileData?.is_grouped_band)) && !hideMemoImageEditControls ? (
                        <>
                            <ReactTooltip id={`view text`} effect="solid" place="bottom" backgroundColor="#007bff" />
                            <div
                                class="edt-icn ey-icn cursor-hand"
                                data-for={`view text`}
                                data-tip={"View Text"}
                                onClick={() =>
                                    openChartItemConfigModal({
                                        bandName: currentBand,
                                        chartKey:
                                            item.isImageBand ||
                                            item?.isMemo ||
                                            item?.isExecutiveSummaryParent ||
                                            item?.isDynamicBBI ||
                                            item?.isDynamicBSI ||
                                            item?.isDynamicBAI
                                                ? item.docKey
                                                : item.name,
                                        entity: entity,
                                        itemConfig: item.config,
                                        isImageBand: item.isImageBand,
                                        isMemo: item?.isMemo || item?.isExecutiveSummaryParent,
                                        isDynamicBBI: item?.isDynamicBBI,
                                        isDynamicBSI: item?.isDynamicBSI,
                                        isDynamicBAI: item?.isDynamicBAI
                                    })
                                }
                            >
                                <img src="/img/sm-charts-img-eye.svg" />
                            </div>
                        </>
                    ) : null}
                    {item.isImageBand ? (
                        <>
                            <div
                                class="edt-icn ey-icn cursor-hand"
                                onClick={() =>
                                    toggleImageListForBandModal(
                                        {
                                            bandName: currentBand,
                                            chartKey: item.isImageBand ? item.docKey : item.name,
                                            entity: entity,
                                            itemConfig: item.config,
                                            isImageBand: item.isImageBand
                                        },
                                        true
                                    )
                                }
                            >
                                <img src="/img/sm-charts-img-eye.svg" />
                            </div>
                        </>
                    ) : null}
                </div>
            </div>
            <div className="cont-sec">
                <div className="icons-sec">
                    <img src={`/img/${item.entityIcon}`} />
                </div>
                <div className="tile-name-badge-container">
                    <EllipsisTooltipText text={displayName} className="view-chart-item-title-text" asHeading />
                    {tileName && <span className="tile-name-badge mt-1">{tileName}</span>}
                </div>
            </div>
            {(item.hasConfig && (entity === "project" || entity === "assets" || entity == "energy_mng")) ||
            (item?.name?.startsWith("Comparative Analysis Band") && !isSouceTemplate) ? (
                <div className="fot-sec top-border">
                    <div className="fot-select">
                        {(item.isRecommendation ||
                            (!item?.isSortedRecom &&
                                !isExcelExport &&
                                !item?.isMemo &&
                                !item?.isExecutiveSummaryParent &&
                                !item?.isBsi &&
                                !item?.isBbi &&
                                !item?.isBai &&
                                !item?.isCAband &&
                                item.name !== "Text Band" &&
                                !item.isCAband &&
                                item.name !== "energy_band" &&
                                !item?.name?.startsWith("asset_band"))) && (
                            <>
                                {!(
                                    (item?.tileData?.band1?.config_filter && Object.keys(item.tileData.band1.config_filter).length > 0) ||
                                    (item?.tileData?.config_filter && Object.keys(item.tileData.config_filter).length > 0) ||
                                    (!item?.isBai && item?.tileData?.band1?.mfilter?.recommendations?.length === 0) ||
                                    item?.tileData?.recommendations?.length === 0 ||
                                    item?.tileData?.band1?.mfilter?.asset_ids?.length === 0
                                ) && (
                                    <span
                                        className={`badge ${
                                            (item.isImageBand || item.isMultipleRecommendation || item.isRecommendation || item.isOnePager) &&
                                            !item.totalChartCount &&
                                            item.isSelected
                                                ? "sm-chart-chart-count-indicator"
                                                : ""
                                        }`}
                                    >
                                        {item?.totalChartCount}
                                    </span>
                                )}
                                <span className="nme">
                                    {item.isMultipleRecommendation || item.isRecommendation || item.isOnePager || item?.isAsset
                                        ? item?.isAssetOnePager || item?.isAsset
                                            ? (item?.tileData?.band1?.config_filter && Object.keys(item.tileData.band1.config_filter).length > 0) ||
                                              (item?.tileData?.config_filter && Object.keys(item.tileData.config_filter).length > 0) ||
                                              item?.tileData?.band1?.mfilter?.asset_ids?.length === 0
                                                ? "All Assets"
                                                : "Assets"
                                            : (item?.tileData?.band1?.config_filter && Object.keys(item.tileData.band1.config_filter).length > 0) ||
                                                (item?.tileData?.config_filter && Object.keys(item.tileData.config_filter).length > 0) ||
                                                item?.tileData?.band1?.mfilter?.recommendations?.length === 0 ||
                                                item?.tileData?.recommendations?.length === 0
                                              ? "All Recommendations"
                                              : "Recommendations"
                                        : `Selected ${item.isImageBand ? "Images" : "Charts"}`}
                                </span>
                            </>
                        )}
                    </div>
                    <div className="btn-area">
                        <>
                            <div className="icon"></div>
                            {item.name !== "multi_recommendation" ? (
                                <button
                                    className="btn btn-conf"
                                    onClick={() => {
                                        if (
                                            (entity === "project" || entity === "assets" || entity === "energy_mng") &&
                                            item?.isExecutiveSummaryParent &&
                                            openExecutiveSummaryHierarchyConfig
                                        ) {
                                            openExecutiveSummaryHierarchyConfig({
                                                entity,
                                                bandName: currentBand,
                                                chartKey: item.docKey
                                            });
                                            return;
                                        }
                                        item?.name?.startsWith("Comparative Analysis Band") &&
                                        Object.keys(item?.tileData || {})?.includes("reverse_cmp_analysis")
                                            ? editImageBand(
                                                  {
                                                      bandName: currentBand,
                                                      chartKey: item.docKey,
                                                      entity: entity,
                                                      name: item.name,
                                                      selectedTile: item
                                                  },
                                                  item.isCAband ? "CA" : "image"
                                              )
                                            : openChartItemConfigModal({
                                                  bandName: currentBand,
                                                  chartKey:
                                                      item.isImageBand ||
                                                      item?.isMemo ||
                                                      item.isMultipleRecommendation ||
                                                      item.isRecommendation ||
                                                      item.isOnePager ||
                                                      item?.isSortedRecom ||
                                                      item?.isDynamicSystem ||
                                                      item?.isDynamicBBI ||
                                                      item?.isDynamicBSI ||
                                                      item?.isDynamicBAI
                                                          ? item.docKey
                                                          : item.name,
                                                  entity: entity,
                                                  itemConfig: item.config,
                                                  isImageBand: item.isImageBand,
                                                  isMemo: item?.isMemo,
                                                  isBbi: item?.isBbi,
                                                  isBai: item?.isBai,
                                                  isBsi: item?.isBsi,
                                                  isDynamicBBI: item?.isDynamicBBI,
                                                  isDynamicBSI: item?.isDynamicBSI,
                                                  isDynamicBAI: item?.isDynamicBAI,
                                                  recomType: item.isMultipleRecommendation
                                                      ? "multiple"
                                                      : item?.isAsset || (item?.isAssetOnePager && entity === "project")
                                                        ? "asset"
                                                        : item.isOnePager
                                                          ? "onepager"
                                                          : item.isRecommendation
                                                            ? "normal"
                                                            : ""
                                              });
                                    }}
                                >
                                    {item?.isExecutiveSummaryParent ? "View Child Bands" : "View Config"} <img src="/img/blue_arrow_right.svg" />
                                </button>
                            ) : null}
                            <div className="icon"></div>
                            {((item.docKey?.includes("normal_recom") ||
                                item.docKey?.includes("multi_recommendation") ||
                                item.docKey?.includes("recom_onepager") ||
                                item.docKey?.startsWith("multisystem") ||
                                item.docKey === "system") &&
                                item.filter) ||
                            item.isCAband ? (
                                <button className="btn btn-conf" onClick={() => openFilterModal(item?.docKey)}>
                                    View Filters <img src="/img/blue_arrow_right.svg" />
                                </button>
                            ) : null}
                        </>
                    </div>
                </div>
            ) : null}
            {/* {!item?.isCAband && (
                <div className="fot-sec top-border">
                    <div className="btn-area">
                        <div className="icon"></div>
                        {(item.name === "Recommendation Table" ||
                            item.name === "Recommendation Summary" ||
                            item.name === "Recommendation One Pager") &&
                        item.filter ? (
                            <button className="btn btn-conf" onClick={() => openFilterModal(item?.docKey)}>
                                View Filters <img src="/img/blue_arrow_right.svg" />
                            </button>
                        ) : null}
                    </div>
                </div>
            )} */}
        </div>
    );
};
export default ViewChartItemForModal;
